var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { attrs: { "data-vv-scope": "questions" } }, [
    _vm.securityQuestions && Object.values(_vm.securityQuestions).length
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            _vm._l(Object.values(_vm.securityQuestions), function(
              question,
              index
            ) {
              return _c(
                "div",
                { key: index, staticClass: "mt-3" },
                [
                  _c("b", [_vm._v(_vm._s(question.text))]),
                  _c(
                    "vs-select",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "w-100 con-select autocompletex",
                      attrs: {
                        autocomplete: "",
                        label: "Seleccione",
                        name: "valor",
                        danger: _vm.errors.has("questions.valor"),
                        "danger-text": _vm.errors.first("questions.valor")
                      },
                      model: {
                        value: question.valor,
                        callback: function($$v) {
                          _vm.$set(question, "valor", $$v)
                        },
                        expression: "question.valor"
                      }
                    },
                    _vm._l(question.opciones, function(option, index) {
                      return _c("vs-select-item", {
                        key: index,
                        attrs: { value: option.id, text: option.texto }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "text-right mt-4" },
      [
        _c(
          "b-button",
          {
            attrs: { disabled: _vm.loading, variant: "primary" },
            on: { click: _vm.verifySecurityQuestions }
          },
          [
            _vm._v(" Verificar "),
            _vm.loading
              ? _c("b-spinner", { attrs: { small: "", variant: "primary" } })
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }